export const LOGIN_LINK = `https://login.xing.com/?dest_url=https://www.xing.com/search/members&sc_o=publicsearch_login_to_search_member_cta_click`;
